(() => {
  const Northyard = window.Northyard;
  if (!Northyard || Northyard.productCardsReady) return;
  Northyard.productCardsReady = true;
  const cardImageSource = (card, source) => {
    if (card.dataset.cardLayout !== 'recommendation') return source;
    const url = new URL(source, window.location.origin);
    if (url.origin === window.location.origin || url.hostname === 'cdn.shopify.com') {
      const width = Math.ceil(card.clientWidth * Math.min(window.devicePixelRatio || 1, 3));
      url.searchParams.set('width', String(Math.min(1200, Math.max(300, width))));
    }
    return url.href;
  };

  const setCardGallery = (card, media, startIndex = 0) => {
    card._galleryMedia = media;
    card._galleryIndex = Math.max(0, Math.min(startIndex, media.length - 1));
    const link = Northyard.qs('.product-card__image-link', card);
    let image = Northyard.qs('.product-card__image', card);
    const active = media[card._galleryIndex];
    if (!active && link) link.textContent = card.dataset.mediaUnavailableLabel;
    if (active && !image && link) {
      image = document.createElement('img');
      image.className = 'product-card__image';
      image.loading = 'lazy';
      link.replaceChildren(image);
    }
    if (image && active) {
      const template = document.createElement('template');
      template.innerHTML = active.html || '';
      const responsive = template.content.querySelector('img');
      const source = cardImageSource(card, active.src);
      const sizes = image.sizes || Math.ceil(image.clientWidth || card.clientWidth) + 'px';
      image.width = active.width || image.width || 1200;
      image.height = active.height || image.height || 1600;
      if (window.NorthyardProgressive) {
        window.NorthyardProgressive.set(image, { src: source, srcset: responsive?.srcset || '', sizes });
        window.NorthyardProgressive.upgrade(image);
      } else { image.src = source; image.srcset = responsive?.srcset || ''; image.sizes = sizes; }
      image.alt = Northyard.ProductState.imageAlt(active, card.querySelector('.product-card__title')?.textContent.trim());
    }
    const dots = Northyard.qs('[data-card-image-dots]', card);
    if (dots) {
      dots.innerHTML = media.slice(0, 7).map((item, index) => (
        '<i class="' + (index === card._galleryIndex ? 'is-active' : '') + '"></i>'
      )).join('');
    }
  };

  const loadCardGallery = async (card) => {
    const version = card._galleryVersion || 0;
    try {
      const source = Northyard.qs('[data-card-product-link]', card)?.href || card.dataset.productUrl;
      const payload = card._selectionState || await Northyard.ProductState.request(source);
      if (!card.isConnected || version !== (card._galleryVersion || 0)) return [];
      setCardGallery(card, payload.media.filter((item) => item.type === 'image'));
      return card._galleryMedia || [];
    } catch (error) {
      const message = Northyard.qs('[data-card-state-error]', card);
      if (message) { message.textContent = card.dataset.loadErrorLabel; message.hidden = false; }
      return [];
    }
  };

  const moveCardGallery = async (card, direction) => {
    const media = card._galleryMedia && card._galleryMedia.length
      ? card._galleryMedia
      : await loadCardGallery(card);
    if (!media.length) return;
    const next = ((card._galleryIndex || 0) + direction + media.length) % media.length;
    setCardGallery(card, media, next);
    Northyard.emit('carousel_interaction', {
      type: 'product_image',
      product_id: card.dataset.productId,
      direction
    });
  };

  const selectCardSwatch = async (button, track = true) => {
    const card = button.closest('[data-product-card]');
    if (!card) return;
    const version = card._galleryVersion = (card._galleryVersion || 0) + 1;
    Northyard.qsa('[data-card-swatch]', card).forEach((swatch) => {
      swatch.setAttribute('aria-pressed', String(swatch === button));
    });
    const ids = card.dataset.optionValues.split(',');
    ids[Number(card.dataset.colorIndex)] = button.dataset.optionValueId;
    const desired = Northyard.ProductState.selectionUrl(card.dataset.productUrl, { optionValues: ids });
    card.dataset.activeColor = button.dataset.color;
    Northyard.qsa('[data-card-product-link]', card).forEach((link) => { link.href = desired.href; });
    const colorName = Northyard.qs('[data-card-color-name]', card);
    if (colorName) colorName.textContent = button.dataset.color;
    const errorNode = Northyard.qs('[data-card-state-error]', card);
    if (errorNode) errorNode.hidden = true;
    const price = Northyard.qs('[data-card-price]', card);
    const compare = Northyard.qs('[data-card-compare]', card);
    const sale = Northyard.qs('[data-card-sale-badge]', card);
    const sold = Northyard.qs('[data-card-sold-badge]', card);
    if (price) price.textContent = card.dataset.loadingLabel;
    if (compare) compare.hidden = true;
    if (sale) sale.hidden = true;
    if (sold) sold.hidden = true;
    card.setAttribute('aria-busy', 'true');
    card._selectionState = null;
    card._galleryMedia = null;
    if (track) Northyard.emit('color_select', { product_id: card.dataset.productId, color: button.dataset.color, location: 'product_card' });
    const finishImageWait = window.NorthyardImages?.wait(Northyard.qs('.product-card__image-link', card));
    try {
      const result = await Northyard.ProductState.card(card.dataset.productUrl, { optionValues: ids, fresh: true });
      if (!card.isConnected || version !== card._galleryVersion) return;
      const variant = result.variant;
      if (price) price.textContent = variant
        ? (result.varies ? card.dataset.fromTemplate.replace('__PRICE__', variant.price_formatted) : variant.price_formatted) : '—';
      if (compare) { compare.textContent = variant?.compare_formatted || ''; compare.hidden = !variant?.compare_formatted; }
      if (sale) {
        sale.textContent = variant ? Northyard.discountLabel(variant.price, variant.compare_at_price) : '';
        sale.hidden = !sale.textContent;
      }
      if (sold) sold.hidden = result.available;
      button.classList.toggle('is-unavailable', !result.available);
      button.dataset.available = String(result.available);
      button.setAttribute('aria-label', button.dataset.color + (result.available ? '' : ', ' + card.dataset.soldLabel));
      if (variant) {
        button.dataset.variantId = variant.id;
        const url = Northyard.ProductState.selectionUrl(card.dataset.productUrl, { variantId: variant.id });
        Northyard.qsa('[data-card-product-link]', card).forEach((link) => { link.href = url.href; });
      }
      card._selectionState = result.payload;
      setCardGallery(card, result.payload.media.filter((item) => item.type === 'image'));
      card.dataset.needsState = 'false';
    } catch (error) {
      if (version !== card._galleryVersion) return;
      if (price) price.textContent = '—';
      if (errorNode) {
        errorNode.textContent = card.dataset.loadErrorLabel;
        errorNode.hidden = false;
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'text-link';
        retry.textContent = document.querySelector('[data-quick-view]')?.dataset.labelTryAgain || card.dataset.loadingLabel;
        retry.addEventListener('click', () => selectCardSwatch(button, false));
        errorNode.append(retry);
      }
    } finally {
      finishImageWait?.();
      if (version === card._galleryVersion) card.removeAttribute('aria-busy');
    }
  };

  const cardStateObserver = new IntersectionObserver((entries) => {
    entries.filter((entry) => entry.isIntersecting).forEach(({ target: card }) => {
      cardStateObserver.unobserve(card);
      const selected = Northyard.qs('[data-card-swatch][aria-pressed="true"]', card);
      if (selected) selectCardSwatch(selected, false);
      else {
        const control = document.createElement('button');
        control.dataset.color = card.dataset.activeColor;
        control.dataset.optionValueId = card.dataset.optionValues.split(',')[Number(card.dataset.colorIndex)];
        control.closest = () => card;
        selectCardSwatch(control, false);
      }
    });
  }, { rootMargin: '0px' });

  const initializedCards = new WeakSet();
  const initCards = (root = document) => Northyard.qsa('[data-product-card]', root).forEach((card) => {
    if (initializedCards.has(card)) return;
    initializedCards.add(card);
    Northyard.qsa('[data-card-swatch]', card).forEach((swatch) => {
      if (!swatch.style.getPropertyValue('--swatch-image') && !swatch.style.getPropertyValue('--swatch-color')) {
        swatch.style.setProperty('--swatch-color', Northyard.colorCss(swatch.dataset.color));
      }
    });
    if (card.dataset.needsState === 'true') cardStateObserver.observe(card);

    const previous = Northyard.qs('[data-card-image-prev]', card);
    const next = Northyard.qs('[data-card-image-next]', card);
    if (previous) previous.addEventListener('click', () => moveCardGallery(card, -1));
    if (next) next.addEventListener('click', () => moveCardGallery(card, 1));

    let touchStart = null;
    let suppressClickUntil = 0;
    const media = Northyard.qs('[data-card-gallery]', card);
    if (media) {
      media.addEventListener('touchstart', (event) => {
        touchStart = event.touches.length === 1 && !event.target.closest('button')
          ? { x: event.touches[0].clientX, y: event.touches[0].clientY }
          : null;
      }, { passive: true });
      media.addEventListener('touchend', (event) => {
        if (!touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touchStart.x;
        const dy = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          suppressClickUntil = performance.now() + 500;
          moveCardGallery(card, dx > 0 ? -1 : 1);
        }
      }, { passive: true });
      media.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
      media.addEventListener('click', (event) => {
        if (performance.now() < suppressClickUntil && event.target.closest('[data-card-product-link]')) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
      media.addEventListener('keydown', (event) => {
        if (card.dataset.cardLayout !== 'recommendation' || !event.target.closest('[data-card-product-link]')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        moveCardGallery(card, event.key === 'ArrowLeft' ? -1 : 1);
      });
    }
  });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    event.preventDefault();
    selectCardSwatch(swatch);
  });

  const initializedRails = new WeakSet();
  const initRails = (root) => Northyard.qsa('[data-product-carousel]', root).forEach((carousel) => {
    if (initializedRails.has(carousel)) return;
    initializedRails.add(carousel);
    const viewport = Northyard.qs('[data-carousel-viewport]', carousel);
    const previous = Northyard.qs('[data-carousel-prev]', carousel);
    const next = Northyard.qs('[data-carousel-next]', carousel);
    const progress = Northyard.qs('[data-carousel-progress]', carousel);
    if (!viewport) return;

    const amount = () => {
      const slide = Northyard.qs('.product-carousel__slide', viewport);
      return slide ? slide.getBoundingClientRect().width + 16 : viewport.clientWidth * 0.8;
    };
    const update = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      if (previous) previous.disabled = viewport.scrollLeft < 5;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll - 5;
      if (progress) {
        const thumb = Math.max(18, (viewport.clientWidth / viewport.scrollWidth) * 100);
        const travel = 100 - thumb;
        const ratio = maxScroll ? viewport.scrollLeft / maxScroll : 0;
        progress.style.width = thumb + '%';
        progress.style.transform = 'translateX(' + ((travel / thumb) * ratio * 100) + '%)';
      }
    };
    if (previous) previous.addEventListener('click', () => {
      viewport.scrollBy({ left: -amount(), behavior: 'smooth' });
      Northyard.emit('carousel_interaction', { type: 'products', direction: 'previous' });
    });
    if (next) next.addEventListener('click', () => {
      viewport.scrollBy({ left: amount(), behavior: 'smooth' });
      Northyard.emit('carousel_interaction', { type: 'products', direction: 'next' });
    });
    viewport.addEventListener('scroll', update, { passive: true });

    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;
    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.target.closest('button, a')) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });
    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 4) moved = true;
      viewport.scrollLeft = startScroll - distance;
    });
    const stop = () => {
      if (dragging && moved) Northyard.emit('carousel_interaction', { type: 'products', direction: 'drag' });
      dragging = false;
      moved = false;
      viewport.classList.remove('is-dragging');
    };
    viewport.addEventListener('pointerup', stop);
    viewport.addEventListener('pointercancel', stop);
    update();
  });

  Northyard.initProductCards = (root = document) => { initCards(root); initRails(root); };
  Northyard.initProductCards();
})();
